import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TaskTypeOnHoldComponent } from './task-type-on-hold.component';

const routes: Routes = [
  { path: '', component: TaskTypeOnHoldComponent, data: { title: 'Service Type On Hold' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaskTypeOnHoldRoutingModule {}

@NgModule({
  imports: [
    TaskTypeOnHoldRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TaskTypeOnHoldComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TaskTypeOnHoldModule {}
